import React, { useEffect, useState } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import VideoPlayer from '../VideoPlayer';


export default function VideoReportDetails() {
  const { id } = useParams();
 const API_URL = `https://api.mogym.ir`;
   const [report, setReport] = useState(null);
  const [allVideos, setAllVideos] = useState([]);
  const [selectedExerciseId, setSelectedExerciseId] = useState(null);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate(); // ✅ اضافه کن

  const fetchData = async () => {
    try {
      const res1 = await fetch(`${API_URL}/api/admin/video-reports/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` }
      });
      const reportData = await res1.json();

      const res2 = await fetch(`${API_URL}/api/admin/exercise-videos`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` }
      });
      const videosData = await res2.json();

      if (!res1.ok || !res2.ok) throw new Error('Failed to load data');

      setReport(reportData.Result);
      setAllVideos(videosData.Result);
    } catch (err) {
      setError('خطا در دریافت اطلاعات');
    } finally {
      setLoading(false);
    }
  };

  const handleReplace = async () => {
    if (!selectedExerciseId) return alert('یک حرکت را انتخاب کنید');
    try {
      const res = await fetch(`${API_URL}/api/admin/replace-video`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`
        },
        body: JSON.stringify({
          OldExerciseId: report.Id,
          NewExerciseId: selectedExerciseId
        })
      });
      if (res.ok) {
        alert('✅ ویدیو با موفقیت جایگزین شد');
        navigate('/admin/videoReports');
      } else {
        alert('❌ خطا در جایگزینی ویدیو');
      }
    } catch {
      alert('❌ ارتباط با سرور برقرار نشد');
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const filteredVideos = allVideos.filter(v =>
    v.Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <p className="p-10 text-center">در حال بارگذاری...</p>;
  if (error || !report) return <p className="text-center text-red-500">{error}</p>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-10 font-vazir">
      <h1 className="text-2xl font-bold mb-6 text-center">🔧 جزئیات گزارش ویدیو</h1>

      <div className="bg-gray-100 dark:bg-[#1f1f2f] p-5 rounded-xl mb-8">
        <p><strong>🎯 آی‌دی حرکت:</strong> {report.Id}</p>
<p><strong>📛 نام فارسی حرکت:</strong> {report.ExerciseNameFa}</p>
<p><strong>🔤 نام لاتین حرکت:</strong> {report.ExerciseNameEn}</p>
        <p><strong>⚠️ نوع گزارش:</strong> {report.Type === 'Broken' ? 'ویدئوی خراب' : 'ویدئوی اشتباه'}</p>
        <p><strong>🎥 آدرس فعلی ویدئو:</strong> <a href={report.CurrentVideoUrl} className="text-blue-500" target="_blank" rel="noreferrer">مشاهده</a></p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4">📁 انتخاب حرکت با ویدیوی صحیح</h2>

        <input
          type="text"
          placeholder="جستجو در لیست حرکات..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-3 mb-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] text-black dark:text-white"
        />

        <select
          value={selectedExerciseId?.toString() || ''}
          onChange={(e) => {
            const id = parseInt(e.target.value, 10);
            setSelectedExerciseId(id);
            const selected = allVideos.find(v => Number(v.ExerciseId) === Number(id));
            setSelectedVideoUrl(selected?.Url || null);
          }}
          className="w-full p-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] text-black dark:text-white"
        >
          <option value="" disabled>یک حرکت انتخاب کنید</option>
          {filteredVideos.map((v) => (
            <option key={`${v.ExerciseId || v.Url}-${Math.random()}`} value={v.ExerciseId?.toString() || ''}>
              {v.Name} ({v.Url})
            </option>
          ))}
        </select>

        {selectedVideoUrl && (
          <div className="mt-1">
            <VideoPlayer url={selectedVideoUrl} title={`preview-${selectedExerciseId}`} exerciseId={selectedExerciseId} />
          </div>
        )}

        <button
          onClick={handleReplace}
          className="mt-6 bg-green-600 text-white px-5 py-2 rounded-xl hover:bg-green-700"
        >
          ✅ جایگزینی ویدیو
        </button>
      </div>
    </div>
  );
}
